import arrow from '../shapes/arrow';
import blot from '../shapes/blot';
import circle from '../shapes/circle';
import line from '../shapes/line';
import pentagon from '../shapes/pentagon';
import rectangle from '../shapes/rectangle';
import star from '../shapes/star';
import triangle from '../shapes/triangle';

export default {

  components: {
    'shape--arrow': arrow,
    'shape--blot': blot,
    'shape--circle': circle,
    'shape--line': line,
    'shape--pentagon': pentagon,
    'shape--rectangle': rectangle,
    'shape--star': star,
    'shape--triangle': triangle,
  },


  props: {
    shape: String,
  },


  computed: {

    componentName() {
      return `shape--${this.shape}`;
    },

  },


  template: /* html */`
  <component :is="componentName"></component>
  `
}